<script lang="ts">
	import { NewsNewsletterPage } from '#lib/websites/news/pages/NewsNewsletterPage/index.js';
	import { page } from '$app/state';
</script>

{#if page.data.showGlobalNav}
	<NewsNewsletterPage />
{:else}
	<div class="bg-gray-0 fixed inset-0 z-30 h-[100vh] w-[100vw]"></div>

	<div
		id="news-ios-overlay"
		class="fixed top-0 bottom-0 z-40 w-[100vw] overflow-scroll"
	>
		<NewsNewsletterPage />
	</div>
{/if}
